<template>
  <div class="expert-column">
    <!-- 头部banner图 -->
    <div class="swiper">
      <div class="toptexts">
        <div class="imgtitle">专家专栏</div>
        <div class="texts">新鲜资讯、随时播报、一网打尽</div>
      </div>
    </div>

    <div class="Bread">
      <Bread :list="breadList" />
    </div>

    <div class="container pa-lr-30 bg-fff ma-b-30 o-hidden">
      <div class="pa-tb-30 flex f-center  search-box ma-tb-20">
        <div class="flex f-center f-between search">
          <el-input
            border="none"
            placeholder="请输入关键字搜索"
            v-model="searchName"
          ></el-input>
          <div class="search-btn" @click="handleClick()">立即搜索</div>
        </div>
      </div>

      <div>
        <el-tabs @tab-click="handleClick" v-model="tabsName">
          <el-tab-pane label="专栏列表" name="1">
            <specialColumn  ref="specialColumn"></specialColumn>
          </el-tab-pane>
          <el-tab-pane label="专家列表" name="2">
           <expertColumn ref="expertColumn"></expertColumn>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import Bread from "@/components/Bread.vue";
import expertColumn from "@/components/expert/expertColumn.vue";
import specialColumn from "@/components/expert/specialColumn.vue";
// import { getExpertList } from "../../api.js";
var _this;
export default {
  name: "ExpertColumn",
  components: { Bread,expertColumn, specialColumn},
  data() {
    return {
      searchName:'',//列表搜索关键词
      tabsName:'1',
      breadList: [{ name: "专家专栏" }],
    };
  },
  created() {
    _this = this;
  },
  methods: {
    //点击切换种类
    handleClick() {
      console.log(_this.tabsName);
      if(_this.tabsName=='1'){
        _this.$refs.expertColumn.loadDataSearch(_this.searchName)
      }else if(_this.tabsName=='2'){
        _this.$refs.specialColumn.loadDataSearch(_this.searchName)

      }
    }
  },
};
</script>
<style lang="scss" scoped>
.expert-column {
  .swiper {
    width: 100%;
    height: 314px;
    background-image: url(../../img/ExpertColumn.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: relative;
    .toptexts {
      width: 736px;
      position: absolute;
      top: 28%;
      margin: 0 auto;
      left: 50%;
      margin-left: -368px;
      font-size: 20px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;

      color: #fff;
      opacity: 0.75;
      text-align: center;
      .texts {
        line-height: 30px;
        letter-spacing: 3px;
        font-size: 16px;
      }
      .imgtitle {
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 20px;
      }
    }
  }
  .content {
    position: relative;
    height: 240px;
  }
  .img {
    width: 205px;
    height: 205px;
    box-shadow: 0px 0px 10px 0px rgba(6, 0, 1, 0.18);
    border-radius: 205px;
    background: transparent;
    z-index: 1;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    img {
      box-shadow: 0px 0px 10px 0px rgba(6, 0, 1, 0.18);
    }
  }
  .boxs {
    width: 76%;
    height: 220px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(6, 0, 1, 0.18);
    border-radius: 10px;
    padding: 10px 40px 10px 100px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;

    .tips {
      background: #eb6100;
      border-radius: 10px;
      width: 90px;
      height: 30px;
    }
    .tips2 {
      background: #bfbfbf;
      height: 30px;
      padding: 0 10px;
      border-radius: 10px;
    }
  }
  .search-box {
    position: relative;
    .search {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      background: #eeeeee;
      border-radius: 33px;
      width: 280px;
      .el-input {
        border-radius: 33px;
        .el-input__inner {
          border-radius: 33px;
          background: #eeeeee;
          border: none !important;
        }
      }
      .search-btn {
        background: #00479d;
        border-radius: 0px 33px 33px 0px;
        height: 40px;
        line-height: 40px;
        padding: 0 15px;
        width: 100px;
        color: #fff;
        cursor: pointer;
      }
    }
  }
}
</style>
